import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const PurchaseOrder = () => {
  return (
    <PrintPreferenceTabs type="purchase_order"></PrintPreferenceTabs>
  );
};
export default PurchaseOrder;

